import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import styled from "styled-components";
//import Home from "../containers/Home/ContainerHome";
import ContainerHomePublica from "../containers/Home/ContainerHomePublica";
import HomePublicaLayoutFront from "./Layout/HomePublicaFront";
import HomePublicaLayout from "./Layout/HomePublica";
import PreguntasFrecuentesLayout from "./Layout/PreguntasFrecuentes";
import PreguntasFrecuentes from "../containers/Home/ContainerPreguntasFrecuentes";
//import Perfil from "./Perfil/Perfil";
import ProductosMenu from "../containers/Home/ContainerProductosMenu";

// caso para iframe de indemnizaciones
import ContainerPantallaIframe from "../containers/Indemnizacion/ContainerPantallaIframe";

import ContainerPerfil from "../containers/perfil/ContainerPerfil";
import ContainerLogin from "../containers/Login/ContainerLogin";
import ContainerRecuperarSesionMovil from "../containers/Login/ContainerRecuperarSesionMovil";
import CambiarContrasenia from "./Perfil/Cambiar_contrasena";
import RecuperarContrasenia from "./Login/Recuperar_contrasena";
import VerificarToken from "./Login/VerificarToken";
import LayoutRoute from "./Layout/LayoutRoute";
import EmptyLayout from "./Layout/EmptyLayout";
import DisclaimerLayout from "./Layout/DisclaimerLayout";
import ActualizarDisclaimer from "./Login/ActualizarDisclaimer";
import ContainerCotizacion from "../containers/Cotizacion/ContainerCotizacion";
import ContainerCotizacion2 from "../containers/Cotizacion/ContainerCotizacion2";
import ContainerCotizacion2Renovacion from "../modules/renovaciones/pages/EditarRenovacion/ContainerCotizacion2Renovacion";
import ContainerCotizacion3Resumen from "../containers/Cotizacion/ContainerCotizacion3";
import ContainerCotizacion3ResumenRenovacion from "../modules/renovaciones/pages/ResumenRenovacion/ContainerCotizacion3Renovacion";
import ContainerCotizacion4Confirmacion from "../containers/Cotizacion/ContainerCotizacion4";
import ContainerCotizacion4ConfirmacionRenovacion from "../modules/renovaciones/pages/DatosContratante/ContainerCotizacion4Renovacion";
import ContainerCotizacion5ConfirmacionFinal from "../containers/Cotizacion/ContainerCotizacion5";
import Cotizacion5FinalAsesor from "../components/Cotizacion/Cotizacion5FinalAsesor";
import Cotizacion5FinalAsesorRenovacion from "../modules/renovaciones/pages/FinalRenovacion/Cotizacion5FinalAsesorRenovacion";
import RecuperarCotizacionError from "../components/Cotizacion/RecuperarCotizacionError";
import ListadoCompras from "../containers/Compras/ContainerCompras";
import ListadoCotizaciones from "../containers/Cotizacion/ListadoCotizaciones";
import ContainerPagos from "../containers/Cotizacion/ContainerPagos";
import ContainerPagosRenovaciones from "../modules/renovaciones/pages/FormaPago/ContainerPagosRenovaciones";
import Principal from "../containers/Cotizacion/ContainerPrincipal";
import Cotizadores from "../containers/Cotizador/ContainerCotizadores";
import { connect } from "react-redux";
import cronSesion from "./cronSesion";
import containerLogout from "../containers/Login/ContainerLogout";
import ContainerFinalCotizacionGeneral from "../containers/FinalCotizacionGeneral/FinalCotizacionGeneral";
//Cotizador Lineas Financieras ------------------------
import ContainerCotizacionFinanciero from "../containers/CotizacionFinanciero/ContainerCotizacionFinanciero";
import ContainerCotizacionFinanciero2 from "../containers/CotizacionFinanciero/ContainerCotizacionFinanciero2";
import ContainerCotizacionFinanciero3 from "../containers/CotizacionFinanciero/ContainerCotizacionFinanciero3";
import ContainerCotizacionFinanciero4 from "../containers/CotizacionFinanciero/ContainerCotizacionFinanciero4";

import ContainerCotizacionResponsabilidad from "../containers/CotizacionFinanciero/CotizacionResponsabilidad/ContainerCotizacionResponsabilidad";

import ContainerCotizacionResponsabilidad2 from "../containers/CotizacionFinanciero/CotizacionResponsabilidad/ContainerCotizacionResponsabilidad2";
//Cotizador Pymes ------------------------
import ContainerCotizacionPymes from "../containers/CotizacionPymes/ContainerCotizacionPymes";
import ContainerCotizacionPymesDiners from "../containers/CotizacionPymes/ContainerCotizacionPymesDiners";
import ContainerRcAndida from "../containers/ContainerRcAndida";

import ContainerCotizacionAPersonal from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAPersonal";
import ContainerCotizacionAPersonal2 from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAPersonal2";
import ContainerCotizacionAPersonal3 from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAPersonal3";
import ContainerCotizacionAPersonalRec from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAPersonalRec";
import ContainerDebitoAutomatico from "../containers/Cotizacion/ContainerDebitoAutomatico";
import ContainerCotizacionAccPersonal from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAccPersonal";
import ContainerCotizacionAccPersonal2 from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAccPersonal2";
import ContainerCotizacionAccPersonal3 from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAccPersonal3";
import ContainerCotizacionAccPersonalRec from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAccPersonalRec";

import ContainerCotizacionAccPersonalAbierto from "../containers/CotizacionAccidentePersonalAbierto/ContainerCotizacionAccPersonalAbierto";
import ContainerCotizacionAccPersonalAbierto2 from "../containers/CotizacionAccidentePersonalAbierto/ContainerCotizacionAccPersonalAbierto2";
//Cotizador Hogar -------------------
import ContainerCotizacionHoparPaso1 from "../containers/CotizacionHogar/ContainerCotizacionPaso1";
import ContainerCotizacionHoparPaso2 from "../containers/CotizacionHogar/ContainerCotizacionPaso2";
import ContainerCotizacionHoparPaso3 from "../containers/CotizacionHogar/ContainerCotizacionPaso3";
import ContainerCotizacionHoparPaso4 from "../containers/CotizacionHogar/ContainerCotizacionPaso4";
import ContainerCotizacionHoparPaso5 from "../containers/CotizacionHogar/ContainerCotizacionPaso5";
import ContainerCotizacionHoparPaso6 from "../containers/CotizacionHogar/ContainerCotizacionPaso6";
import ContainerRecuperarCotizacionHogar from "../containers/CotizacionHogar/ContainerRecuperarCotizacionHogar";
import ContainerCotizacionDatosPersonales from "../containers/CotizacionHogar/ContainerCotizacionDatosPersonales";
//Datos Facturacion
import ContainerDatosFacturacion from "../containers/DatosFacturacion/ContainerDatosFacturacion";
import ContainerDatosFacturacionPymes from "../modules/renovaciones/pages/DatosFacturacionPymes/ContainerDatosFacturacionPymes";
//Datos Renovaciones
import ContainerRenovaciones from "../containers/Renovaciones/ContainerRenovaciones";
import MisPagosContainer from "../containers/MisPagos/MisPagosContainer";
import MisComprasContainer from "../containers/MisCompras/MisComprasContainer";
import EstadoSuscripcionContainer from "../containers/MisCompras/EstadoSuscripcionContainer";
//import Mantenimiento from "../containers/EnMantenimiento/ContainerMantenimiento";
//Fin Cotizador Hogar----------------

//Formulario Vinculacion
import ContainerFormularioVinculacion from "../containers/FormularioVinculacion/FormularioVinculacion";
import ContainerFormularioVinculacionRenovacion from "../modules/renovaciones/pages/FormularioVinculacion/FormularioVinculacionRenovacion";
import ContainerReCompra from "../containers/Compras/ContainerReCompra";
import ContainerApAbierto from "./CotizacionAccidentePersonalAbierto/ContainerApAbierto";
import ComponentApAbiertoResumen from "./CotizacionAccidentePersonalAbierto/ComponentApAbiertoResumen";
import ComponentApAbiertoDatosCliente from "./CotizacionAccidentePersonalAbierto/ComponentApAbiertoDatosCliente";
import ComponentApAbiertoCategoria from "./CotizacionAccidentePersonalAbierto/ComponentApAbiertoCategoria";
import ContainerCotizacionAPersonalRecAbierto from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAPersonalRecAbierto";
import ContainerCargaVidas from "./CargaVidas/ContainerCargaVidas";
import ContainerIndividual from "./Compras/CotizacionIndividual/ContainerIndividual";
import ContainerCotizadorParametrico from "./CotizadorParametrico/ContainerCotizadorParametrico";
import ErrorPage from "./ErrorPage";
import NotFound from "./NotFound";
import ContainerCotizacionAPersonalRecCortoPlazo from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAPersonalRecCortoPlazo";
import ContainerCotizacionAccPersonalVigencia from "../containers/CotizacionAccidentePersonal/ContainerCotizacionAccPersonalVigencia";
import ContainerRenovacionesListado from "../modules/renovaciones/pages/ListadoRenovaciones/ContainerRenovacionesListado";
import ContainerRenovacionItem from "../modules/renovaciones/pages/Renovacion/ContainerRenovacionItem";
import ContainerDebitoAutomaticoRenovacion from "../modules/renovaciones/pages/FormaPago/ContainerDebitoAutomaticoRenovacion";

import { usePermiso } from "../hooks/usePermisoPagina";
import TablaPolizasVigentes from "../containers/PolizasEmitidasVigentes/TablaPolizasVigentes";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";
import NotAuthorized from "./NotAuthorized";
import EndososBeneficiarios from "../containers/EndososBeneficiarios/EndososBeneficiarios";
//Facturación AP 
import ComponentApFacturacionSlip from "./CotizacionAccidentePersonalFacturacion/ComponentApFacturacionSlip";
import ComponentApFacturacionPlanes from "./CotizacionAccidentePersonalFacturacion/ComponentApFacturacionPlanes";
import ComponentApFacturacionVidas from "./CotizacionAccidentePersonalFacturacion/ComponentApFacturacionVidas";
import ComponentApFacturacionFV from "./CotizacionAccidentePersonalFacturacion/ComponentApFacturacionFV";
import ComponentApFacturacionResumen from "./CotizacionAccidentePersonalFacturacion/ComponentApFacturacionResumen";
import DatosFacturacionAp from "./CotizacionAccidentePersonalFacturacion/DatosFacturacionAp";
import ComponentApFacturacionPagadores from "./CotizacionAccidentePersonalFacturacion/ComponentApFacturacionPagadores";
import ZeroRoutes from "../modules/zero/ZeroRoutes";
import MotosRoutes from "../modules/motos/MotosRoutes";

import ContainerFormaPagoPymes from "../modules/renovaciones/pages/FormaPago/ContainerFormaPagoPymes";
import ContainerDebitoAutomaticoPymes from "../modules/renovaciones/pages/FormaPago/ContainerDebitoAutomaticoPymes";
import PlanesPagoPolizasEmitidas from "../containers/PolizasEmitidasVigentes/PlanesPago/PlanesPagoPolizasEmitidas";

import CompromisosRoutes from "../modules/compromisos/CompromisosRoutes";

const MainSection = styled.main``;
const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split("/").pop()}`;
};
// const MainSection = styled.main``;
// const getBasename = () => {
//   return `/${process.env.PUBLIC_URL.split("/").pop()}`;
// };

//Esta funcion sirve para verificar cuando el usuario no este logueado en la aplicacion redireccionarle al path que definamos
const ProtectedRouteLogin = ({
  component: Comp,
  loggedIn,
  layout: Layout,
  path,
  pathredirect,
  carritovisible,
  datosCotizador,
  ...rest
}) => {
  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        let ObtenerSearch = casosRedireccionamiento(rest);
        const { pathname, search } = rest.location;

        return loggedIn ? (
          <LayoutRoute
            exact
            path={path}
            layout={Layout}
            component={Comp}
            carritoVisible={carritovisible}
            datosCotizador={datosCotizador}
          />
        ) : (
          <div>
            {console.log("pathredirect", pathredirect, ObtenerSearch)}
            <Redirect
              to={{
                pathname: pathredirect,
                search: ObtenerSearch,
                state: {
                  prevLocation: !ObtenerSearch ? pathname + search : "",
                  error: "You need to login first!",
                },
              }}
            />
          </div>
        );
      }}
    />
  );
};

const ProtectedRouteLoginPermissions = ({
  component: Comp,
  loggedIn,
  layout: Layout,
  path,
  pathredirect,
  carritovisible,
  datosCotizador,
  ...rest
}) => {

  const { datosUsuario, location } = rest;
  const { permitido, loading } = usePermiso(
    datosUsuario.cliCodigoCore,
    location.pathname
  );

  const renderPage = (ObtenerSearch, pathname, search) => {
    return loggedIn ? (
      <LayoutRoute
        exact
        path={path}
        layout={Layout}
        component={permitido === true ? Comp : NotAuthorized}
        carritoVisible={carritovisible}
        datosCotizador={datosCotizador}
      />
    ) : (
      <div>
        <Redirect
          to={{
            pathname: pathredirect,
            search: ObtenerSearch,
            state: {
              prevLocation: !ObtenerSearch ? pathname + search : "",
              error: "You need to login first!",
            },
          }}
        />
      </div>
    );
  }
  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        let ObtenerSearch = casosRedireccionamiento(rest);
        const { pathname, search } = rest.location;
        return (
          <LoadingScreen
            loading={loading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text={"Cargando..."}
          >
            {renderPage(ObtenerSearch, pathname, search)}
          </LoadingScreen>
        )
      }}
    />
  );
};






const casosRedireccionamiento = (rest) => {
  let accion =
    rest.location.pathname !== undefined && rest.location.pathname !== ""
      ? rest.location.pathname
      : "";

  switch (accion) {
    case "/final-cotizacion":
    case "/final-cotizacion/":
      const queryParams = new URLSearchParams(rest.location.search);
      let id = queryParams.get("id");
      let estado = queryParams.get("estado");
      return `?from=pago&id=${id}&estado=${estado}`;
    default:
      return ``;
  }
};

var cron = require("cron-scheduler");
cron({ on: "* * * * *" }, () => cronSesion());

const Main2 = ({ userIsLoggedIn, estado, fromMobile, ...rest }) => (
  <BrowserRouter>
    <Switch>
      {/* URLs que el usuario no necesitar estar logueado para acceder */}

      <LayoutRoute
        exact
        path='/sessionmobile'
        layout={EmptyLayout}
        component={ContainerRecuperarSesionMovil}
        carritovisible={false}
      />
      <LayoutRoute
        exact
        path='/login'
        layout={EmptyLayout}
        component={ContainerLogin}
      />
      <LayoutRoute
        exact
        path='/'
        layout={HomePublicaLayoutFront}
        component={ContainerHomePublica}
        carritovisible={false}
      />

      {/* <LayoutRoute
        exact
        path="/"
        layout={EmptyLayout}
        component={Mantenimiento}
        carritoVisible={false}
      /> */}
      <LayoutRoute
        exact
        path='/recuperar-contrasenia'
        layout={HomePublicaLayout}
        component={RecuperarContrasenia}
      />
      <LayoutRoute
        exact
        path='/verificar-token/:token'
        layout={HomePublicaLayout}
        component={VerificarToken}
        carritovisible={false}
      />
      <LayoutRoute
        exact
        path='/preguntas-frecuentes'
        layout={PreguntasFrecuentesLayout}
        component={PreguntasFrecuentes}
        carritovisible={false}
      />
      <LayoutRoute
        exact
        path='/detalle-producto'
        layout={HomePublicaLayoutFront}
        component={ProductosMenu}
        carritovisible={false}
      />

      <LayoutRoute
        exact
        path='/logout'
        layout={HomePublicaLayoutFront}
        component={containerLogout}
        carritovisible={false}
      />

      <LayoutRoute
        exact
        path='/final-cotizacion'
        component={ContainerCotizacion5ConfirmacionFinal}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={false}
      />
      <LayoutRoute
        exact
        path='/final-cotizacion-general'
        component={ContainerFinalCotizacionGeneral}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={false}
      />


      {/* URLs de Indemnizaciones  */}

      {<ProtectedRouteLogin
        path='/pantalla-iframe/:tipo'
        loggedIn={userIsLoggedIn}
        component={ContainerPantallaIframe}
        layout={HomePublicaLayoutFront}
        pathredirect={"/login"}
        carritovisible={false}
      />}

      {/* URLs de los cotizadores  */}

      <ProtectedRouteLogin
        path='/cotizacion-financiero'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionFinanciero}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/estatus-cotizacion-financiero'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionFinanciero2}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/limites-cotizacion-financiero'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionFinanciero3}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/resumen-cotizacion-financiero'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionFinanciero4}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-accidente'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAPersonal}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/servicios-cotizacion-accidente'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAPersonal2}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/detalle-cotizacion-accidente'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAPersonal3}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/recuperar-cotizacion-accidentes-personales'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAPersonalRec}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/recuperar-cotizacion-apersonal-abierto'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAPersonalRecAbierto}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/recuperar-cotizacion-apersonal-corto-plazo'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAPersonalRecCortoPlazo}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/cotizacion-individual'
        loggedIn={userIsLoggedIn}
        component={ContainerIndividual}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-carga-vidas'
        loggedIn={userIsLoggedIn}
        component={ContainerCargaVidas}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/recuperar-cotizacion-apersonal'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAccPersonalRec}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      {/*  Accidentes personales */}
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAccPersonal}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-abierto'
        loggedIn={userIsLoggedIn}
        component={ComponentApAbiertoDatosCliente}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Flexi AP',
            codigoFormulario: "formulario-inicial-ap-abierto",
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-abierto-categoria"
          }
        }
      />
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-corto-plazo'
        loggedIn={userIsLoggedIn}
        component={ComponentApAbiertoDatosCliente}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'AP Segmentos Especiales',
            codigoFormulario: 'formulario-inicial-ap-corto-plazo',
            descripcionSeguro: 'AP Segmentos Especiales',
            urlSiguiente: "/cotizacion-accidente-personal-corto-plazo-categoria"
          }
        }
      />

      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-abierto-resumen'
        loggedIn={userIsLoggedIn}
        component={ComponentApAbiertoResumen}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Flexi AP',
            ramo: 'ACCIDENTES PERSONALES ABIERTO',
            codigoFormulario: 'formulario-categorias-ap-abierto',
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-abierto-resumen",
            urlRegresar: "/cotizacion-accidente-personal-abierto-categoria"
          }
        }
      />
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-corto-plazo-resumen'
        loggedIn={userIsLoggedIn}
        component={ComponentApAbiertoResumen}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'AP Segmentos Especiales',
            ramo: 'AP Segmentos Especiales',
            codigoFormulario: 'formulario-categorias-ap-corto-plazo',
            descripcionSeguro: 'AP Segmentos Especiales',
            urlSiguiente: "/cotizacion-accidente-personal-corto-plazo-resumen",
            urlRegresar: "/cotizacion-accidente-personal-corto-plazo-categoria"
          }
        }
      />
      <ProtectedRouteLogin
        path='/cotizador/:cotizadorId'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizadorParametrico}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/recuperarcarrito/:cotizadorId'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizadorParametrico}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-abierto-categoria'
        loggedIn={userIsLoggedIn}
        component={ComponentApAbiertoCategoria}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Flexi AP',
            codigoFormulario: 'formulario-categorias-ap-abierto',
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-abierto-resumen",
            urlRegresar: "/cotizacion-accidente-personal-abierto"
          }
        }
      />
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-corto-plazo-categoria'
        loggedIn={userIsLoggedIn}
        component={ComponentApAbiertoCategoria}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'AP Segmentos Especiales',
            codigoFormulario: 'formulario-categorias-ap-corto-plazo',
            descripcionSeguro: 'AP Segmentos Especiales',
            urlSiguiente: "/cotizacion-accidente-personal-corto-plazo-resumen",
            urlRegresar: "/cotizacion-accidente-personal-corto-plazo"
          }
        }
      />
      <ProtectedRouteLogin
        path='/servicios-cotizacion-accidente-personal'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAccPersonal2}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/vigencia-cotizacion-accidente-personal'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAccPersonalVigencia}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/detalle-cotizacion-accidente-personal'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionAccPersonal3}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      {/* urls Cotizador Responsabilidad */}
      <ProtectedRouteLogin
        path='/cotizacion-responsabilidad'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionResponsabilidad}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/resumen-cotizacion-responsabilidad'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionResponsabilidad2}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      {/* urls Pymes */}
      <ProtectedRouteLogin
        path='/pymes/cotizador'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionPymes}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/pymesDiners/cotizador'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionPymesDiners}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      {/* urls RCAndina */}
      <ProtectedRouteLogin
        path='/rc-andina/cotizador'
        loggedIn={userIsLoggedIn}
        component={ContainerRcAndida}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/rc-andina/cotizador/'
        loggedIn={userIsLoggedIn}
        component={ContainerRcAndida}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      {/* <LayoutRoute
        exact
        path="/pymes/cotizador"
        layout={HomePublicaLayout}
        component={ContainerCotizacionPymes}
        carritoVisible={false}
      /> */}
      {/* URLs que el usuario necesitar estar logueado para acceder */}

      <ProtectedRouteLogin
        path='/actualizar-disclaimer'
        loggedIn={userIsLoggedIn}
        component={(props) => <ActualizarDisclaimer {...props} />}
        layout={DisclaimerLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/principal'
        loggedIn={userIsLoggedIn}
        component={Principal}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      {/* comentar para que no pueda cotizar sin loguearse  --------------------- */}
      <ProtectedRouteLogin
        path="/cotizacion"
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacion}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path="/datos-cotizacion"
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacion2}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />

      <ProtectedRouteLogin
        path="/datos-cotizacion-renovacion"
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacion2Renovacion}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      <ProtectedRouteLogin
        path="/recompra"
        loggedIn={userIsLoggedIn}
        component={ContainerReCompra}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      <ProtectedRouteLogin
        path="/resumen-cotizacion"
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacion3Resumen}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      <ProtectedRouteLogin
        path="/resumen-cotizacion-renovacion"
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacion3ResumenRenovacion}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      <ProtectedRouteLogin
        path="/confirmacion-cotizacion"
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacion4Confirmacion}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      <ProtectedRouteLogin
        path="/confirmacion-cotizacion-renovacion"
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacion4ConfirmacionRenovacion}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      {/* FIN comentar para que no pueda cotizar sin loguearse ----------------- */}

      {/* Descomentar para cotizar vehiculos sin loguearse ******
      <LayoutRoute
        exact
        path='/cotizacion'
        component={ContainerCotizacion}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={false}
      />
      <LayoutRoute
        exact
        path='/datos-cotizacion'
        component={ContainerCotizacion2}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={true}
      /> */}
      <LayoutRoute
        exact
        path="/forma-pago"
        component={ContainerPagos}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={true}
      />
      <LayoutRoute
        exact
        path="/forma-pago-renovacion"
        component={ContainerPagosRenovaciones}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={true}
      />
      {/*  Descomentar para cotizar vehiculos sin loguearse ******
      <LayoutRoute
        exact
        path='/resumen-cotizacion'
        component={ContainerCotizacion3Resumen}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={true}
      />
      <LayoutRoute
        exact
        path='/confirmacion-cotizacion'
        component={ContainerCotizacion4Confirmacion}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={true}
      /> */}
      <LayoutRoute
        exact
        path='/final-cotizacion-detalle'
        component={ContainerCotizacion5ConfirmacionFinal}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={false}
      />
      <LayoutRoute
        exact
        path='/recuperar-cotizacion-error'
        component={RecuperarCotizacionError}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={false}
      />

      <LayoutRoute
        exact
        path='/formulario-vinculacion'
        component={ContainerFormularioVinculacion}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={false}
      />

      <LayoutRoute
        exact
        path='/formulario-vinculacion-renovacion'
        component={ContainerFormularioVinculacionRenovacion}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path="/final-cotizacionbroker"
        loggedIn={userIsLoggedIn}
        component={Cotizacion5FinalAsesor}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path="/final-cotizacionbroker-renovacion"
        loggedIn={userIsLoggedIn}
        component={Cotizacion5FinalAsesorRenovacion}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      {/* <ProtectedRouteLogin path="/final-cotizacion" loggedIn={userIsLoggedIn} component={ContainerCotizacion5ConfirmacionFinal} layout={HomePublicaLayout} pathredirect={"/login"} carritovisible={false} /> */}
      {/*<ProtectedRouteLogin
        path="/final-cotizacion-detalle"
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacion5ConfirmacionFinal}
        layout={!fromMobile?HomePublicaLayout:EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />*/}
      {/*<ProtectedRouteLogin
        path="/recuperar-cotizacion-error"
        loggedIn={userIsLoggedIn}
        component={RecuperarCotizacionError}
        layout={!fromMobile?HomePublicaLayout:EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />*/}
      <ProtectedRouteLogin
        path='/miperfil'
        loggedIn={userIsLoggedIn}
        component={ContainerPerfil}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cambiar-contrasenia'
        loggedIn={userIsLoggedIn}
        component={CambiarContrasenia}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/listado-compras'
        loggedIn={userIsLoggedIn}
        component={ListadoCompras}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/listado-cotizaciones'
        loggedIn={userIsLoggedIn}
        component={ListadoCotizaciones}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/mis-pagos'
        loggedIn={userIsLoggedIn}
        component={MisPagosContainer}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      {/*ES 
      <ProtectedRouteLogin
        path="/forma-pago"
        loggedIn={userIsLoggedIn}
        component={ContainerPagos}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
       <ProtectedRouteLogin
        path="/final-cotizacionbroker"
        loggedIn={userIsLoggedIn}
        component={Cotizacion5FinalAsesor}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path="/forma-pago"
        component={ContainerPagos}
        layout={!fromMobile?HomePublicaLayout:EmptyLayout}
        carritovisible={false}
      />
      <LayoutRoute
        exact
        path="/final-cotizacionbroker"
        component={Cotizacion5FinalAsesor}
        layout={!fromMobile?HomePublicaLayout:EmptyLayout}
        carritovisible={false}
      />

      {/*
       <LayoutRoute
        exact
        path="/lista-cotizadores"
        component={Cotizadores}
        layout={HomePublicaLayout}
        carritovisible={false}
      />*/}

      <ProtectedRouteLogin
        path='/mis-compras'
        loggedIn={userIsLoggedIn}
        component={MisComprasContainer}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/estado-suscripcion-p2p'
        loggedIn={userIsLoggedIn}
        component={EstadoSuscripcionContainer}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/lista-cotizadores'
        loggedIn={userIsLoggedIn}
        component={Cotizadores}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/debito-automatico'
        loggedIn={userIsLoggedIn}
        component={ContainerDebitoAutomatico}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/debito-automatico-renovacion'
        loggedIn={userIsLoggedIn}
        component={ContainerDebitoAutomaticoRenovacion}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/lista-cotizadores2'
        loggedIn={userIsLoggedIn}
        component={Cotizadores}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      {/* <ProtectedRouteLogin path="/final-cotizacion-general" loggedIn={userIsLoggedIn} component={ContainerFinalCotizacionGeneral} layout={HomePublicaLayout} pathredirect={"/login"} carritovisible={false} /> */}

      {/* urls Hogar */}

      <ProtectedRouteLogin
        path='/cotizacion-hogar'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionHoparPaso1}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-hogar-paso2'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionHoparPaso2}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-hogar-paso3'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionHoparPaso3}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-hogar-paso4'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionHoparPaso4}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      <ProtectedRouteLogin
        path='/cotizacion-hogar-paso5'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionHoparPaso5}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      <ProtectedRouteLogin
        path='/recuperar-cotizacion-hogar'
        loggedIn={userIsLoggedIn}
        component={ContainerRecuperarCotizacionHogar}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-hogar-datospersonales'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionDatosPersonales}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/cotizacion-hogar-identificaciones'
        loggedIn={userIsLoggedIn}
        component={ContainerCotizacionHoparPaso6}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      {/*Datos Facturacion */}
      <ProtectedRouteLogin
        path='/datos-facturacion'
        loggedIn={userIsLoggedIn}
        component={ContainerDatosFacturacion}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={true}
      />
      <ProtectedRouteLogin
        path='/datos-facturacion-pymes'
        loggedIn={userIsLoggedIn}
        component={ContainerDatosFacturacionPymes}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path='/forma-pago-pymes'
        loggedIn={userIsLoggedIn}
        component={ContainerFormaPagoPymes}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      {/*Renovaciones */}
      <ProtectedRouteLogin
        path='/renovaciones'
        loggedIn={userIsLoggedIn}
        component={ContainerRenovaciones}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        path='/listado-renovaciones'
        loggedIn={userIsLoggedIn}
        component={ContainerRenovacionesListado}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        path="/renovacion"
        loggedIn={userIsLoggedIn}
        component={ContainerRenovacionItem}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      
      {/* Polizas emitidas vigentes */}
      <ProtectedRouteLoginPermissions
        path='/polizas-emitidas-vigentes'
        loggedIn={userIsLoggedIn}
        component={TablaPolizasVigentes}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosUsuario={rest.userData}
      />
      <ProtectedRouteLogin
        path='/debito-automatico-pymes'
        loggedIn={userIsLoggedIn}
        component={ContainerDebitoAutomaticoPymes}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      {/*FACTURACION AP */}
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-facturacion'
        loggedIn={userIsLoggedIn}
        component={ComponentApFacturacionSlip}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Facturacion AP',
            codigoFormulario: 'formulario-inicial-ap-facturacion',
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-facturacion-contratante"
          }
        }
      />
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-facturacion-contratante'
        loggedIn={userIsLoggedIn}
        component={DatosFacturacionAp}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Facturacion AP',
          //  codigoFormulario: 'formulario-inicial-ap-facturacion-asegurados',
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-facturacion-pagadores",
            urlRegresar: '/cotizacion-accidente-personal-facturacion'
          }
        }
      />
       <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-facturacion-pagadores'
        loggedIn={userIsLoggedIn}
        component={ComponentApFacturacionPagadores}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Facturacion AP',
            codigoFormulario: 'formulario-inicial-ap-facturacion-planes',
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-facturacion-planes",
            urlRegresar: '/cotizacion-accidente-personal-facturacion-contratante'
          }
        }
      />
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-facturacion-planes'
        loggedIn={userIsLoggedIn}
        component={ComponentApFacturacionPlanes}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Facturacion AP',
            codigoFormulario: 'formulario-inicial-ap-facturacion-planes',
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-facturacion-vidas",
            urlRegresar: '/cotizacion-accidente-personal-facturacion-pagadores'
          }
        }
      />
      
      <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-facturacion-vidas'
        loggedIn={userIsLoggedIn}
        component={ComponentApFacturacionVidas}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Facturacion AP',
           // codigoFormulario: 'formulario-inicial-ap-facturacion-asegurados',
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-facturacion-resumen",
            urlRegresar: '/cotizacion-accidente-personal-facturacion-planes'
          }
        }
      />
       <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-facturacion-fv'
        loggedIn={userIsLoggedIn}
        component={ComponentApFacturacionFV}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Facturacion AP',
           // codigoFormulario: 'formulario-inicial-ap-facturacion-asegurados',
            descripcionSeguro: null,
            urlSiguiente: "/lista-cotizadores",
            urlRegresar: '/cotizacion-accidente-personal-facturacion-resumen'
          }
        }
      />
       <ProtectedRouteLogin
        path='/cotizacion-accidente-personal-facturacion-resumen'
        loggedIn={userIsLoggedIn}
        component={ComponentApFacturacionResumen}
        layout={!fromMobile ? HomePublicaLayout : EmptyLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosCotizador={
          {
            titulo: 'Facturacion AP',
          //  codigoFormulario: 'formulario-inicial-ap-facturacion-asegurados',
            descripcionSeguro: null,
            urlSiguiente: "/cotizacion-accidente-personal-facturacion-fv",
            urlRegresar: '/cotizacion-accidente-personal-facturacion-vidas'
          }
        }
      />
      <ProtectedRouteLoginPermissions
        path='/endoso-beneficiario'
        loggedIn={userIsLoggedIn}
        component={EndososBeneficiarios}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosUsuario={rest.userData}
      />
      <ProtectedRouteLoginPermissions
        path='/planes-pago-polizas-emitidas'
        loggedIn={userIsLoggedIn}
        component={PlanesPagoPolizasEmitidas}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
        datosUsuario={rest.userData}
      />
        
      <Route
        path='/motos'
        render={(props) => (
          <MotosRoutes
            {...props}
            ProtectedRouteLogin={ProtectedRouteLogin}
            HomePublicaLayout={HomePublicaLayout}
            userIsLoggedIn={userIsLoggedIn}
          />
        )}
      />
      <Route
        path='/zero'
        render={(props) => (
          <ZeroRoutes
            {...props}
            ProtectedRouteLogin={ProtectedRouteLogin}
            HomePublicaLayout={HomePublicaLayout}
            userIsLoggedIn={userIsLoggedIn}
          />
        )}
      />
      <Route
        path='/compromisos'
        render={(props) => (
          <CompromisosRoutes
            {...props}
            ProtectedRouteLogin={ProtectedRouteLogin}
            HomePublicaLayout={HomePublicaLayout}
            userIsLoggedIn={userIsLoggedIn}
          />
        )}
      />
      <Route
        component={NotFound}
      />
    </Switch>
  </BrowserRouter>
);

const Main3 = ({ userIsLoggedIn, estado, fromMobile }) => (
  <BrowserRouter>
    <Switch>

      <Route
        component={NotFound}
      />
    </Switch>
  </BrowserRouter>
);

const mapStateToProps = (state) => ({
  userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  estado: state,
  fromMobile: state.datosUsuarios.dataUsuario.fromMobile,
  userData: state.datosUsuarios.dataUsuario,
});
//export default Main2;

export default connect(mapStateToProps, null)(Main2);
